<pages-container [title]="id ? 'taskGroup.edit_task' : 'taskGroup.new_task'" [icon]="'assignment'">
  <div back-button>
    <button mat-icon-button class="back-button" (click)="back()" [disabled]="saving()"
            [attr.aria-label]="'tasks.back' | translate">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
  <div buttons>
    <button mat-raised-button class="mat-white-bg" (click)="back()"
            [disabled]="saving()">
      {{ 'tasks.cancel' | translate }}
    </button>
    @if (id) {
      <button mat-raised-button class="mat-white-bg" (click)="deleteTask()"
              [disabled]="saving() || loading() || loadFailed()">
        {{ 'Delete' | translate }}
      </button>
    }
    <button mat-raised-button class="mat-white-bg" (click)="save()"
            [disabled]="saving() || loading() || loadFailed() || taskForm().invalid() || !model().title.trim() || !model().countryId || !model().cityId || !model().organizationId">
      {{ 'tasks.save' | translate }}
    </button>
  </div>
  <form main-content class="task-form-page" ngNoForm (submit)="$event.preventDefault(); save()">
    @if (loading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @if (error()) {
      <p class="error-message" role="alert">{{ error() | translate }}</p>
    }
    @if (!loading() && !loadFailed()) {
    <fieldset [disabled]="saving()">
      @if (role() !== 'organisationAdmin') {
      <div class="location-fields">
        <mat-form-field>
          <mat-label>{{ 'tasks.country' | translate }}</mat-label>
          <mat-select name="countryId" [formField]="taskForm.countryId" (selectionChange)="countryChanged()">
            @for (country of countries(); track country.id) {
              <mat-option [value]="country.id">{{ country.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'tasks.city' | translate }}</mat-label>
          <mat-select name="cityId" [formField]="taskForm.cityId" (selectionChange)="cityChanged()">
            @for (city of cities(); track city.id) {
              <mat-option [value]="city.id">{{ city.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'tasks.organization' | translate }}</mat-label>
          <mat-select name="organizationId" [formField]="taskForm.organizationId">
            @for (organization of organizations(); track organization.id) {
              <mat-option [value]="organization.id">{{ organization.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }
      <mat-form-field>
        <mat-label>{{ 'tasks.task_group' | translate }}</mat-label>
        <mat-select name="taskGroupId" [formField]="taskForm.taskGroupId">
          @for (group of taskGroups(); track group.id) {
            <mat-option [value]="group.id">{{ group.title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'taskGroup.name' | translate }}</mat-label>
        <input matInput name="title" [formField]="taskForm.title">
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'taskGroup.description' | translate }}</mat-label>
        <textarea matInput name="description" [formField]="taskForm.description"
                  cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5"></textarea>
      </mat-form-field>
      <div class="deadline-fields">
        <mat-form-field>
          <mat-label>{{ 'taskGroup.deadline' | translate }}</mat-label>
          <input matInput name="deadlineDate" [formField]="taskForm.deadline" [matDatepicker]="deadlinePicker">
          <mat-datepicker #deadlinePicker [disabled]="saving()"/>
          <mat-datepicker-toggle [for]="deadlinePicker" matSuffix/>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'taskGroup.time' | translate }}</mat-label>
          <input matInput name="deadlineTime" [ngModel]="model().deadline"
                 (ngModelChange)="taskForm.deadline().value.set($event); taskForm.deadline().markAsDirty()"
                 [ngModelOptions]="{standalone: true}" [matTimepicker]="timePicker"
                 [disabled]="saving() || !model().deadline">
          <mat-timepicker #timePicker/>
          <mat-timepicker-toggle [for]="timePicker" matSuffix/>
        </mat-form-field>
      </div>
      @if (certificateEnabled()) {
        <mat-card class="card-container">
          <mat-card-header>
            <mat-card-title>{{ 'certificate.title' | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <certificate-setting (certificateFormResult)="onCertificateFormResult($event)"
                                 [certificateData]="certificateData()"
                                 [organizationId]="model().organizationId"></certificate-setting>
          </mat-card-content>
        </mat-card>
      }
      <mat-card class="card-container">
        <mat-card-header>
          <mat-card-title>{{ 'event.upload_documents' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <document-component [type]="'newTask'" [uniqueId]="'documents'" [readOnly]="saving()"
                              [hideAccess]="true"
                              [uploadedFilesInput]="getEventDocuments()"
                              [deleteFunction]="false"
                              (fileDeleted)="handleFileDeleted($event)"
                              (newFileDeleted)="handleNewFileDeleted($event)"
                              (filesToUpload)="addDocuments($event)">

          </document-component>
        </mat-card-content>
      </mat-card>
    </fieldset>
    }
  </form>
</pages-container>
